var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaySubscribe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.87,
    height: 64,
    viewBox: "0 0 54.87 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_7c3e71292202c9957480f519b952aa9f",
    "data-name": "7c3e71292202c9957480f519b952aa9f",
    transform: "translate(-5.56 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168239",
    "data-name": "Path 168239",
    d: "M35.8,38.47H17.99a2.12,2.12,0,1,0,0,4.24H35.8a2.12,2.12,0,0,0,0-4.24Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168240",
    "data-name": "Path 168240",
    d: "M43.06,6.49a.344.344,0,0,0-.34-.34H31.79a.326.326,0,0,0-.3.18l-.28.54a2.362,2.362,0,0,1-2.08,1.26H24.65a2.345,2.345,0,0,1-2.08-1.25l-.28-.55a.337.337,0,0,0-.3-.18H11.06a.344.344,0,0,0-.34.34V56.38a.34.34,0,0,0,.34.35H39.69a10.553,10.553,0,0,1-.06-1.13,11.356,11.356,0,0,1,3.43-8.15V6.49ZM26.89,10.11A12.28,12.28,0,1,1,14.61,22.39,12.3,12.3,0,0,1,26.89,10.11Zm3.62,43.67H23.27a3.705,3.705,0,0,1,0-7.41h7.24a3.705,3.705,0,0,1,0,7.41Zm5.28-9.07H17.98a4.12,4.12,0,1,1,0-8.24H35.79a4.12,4.12,0,1,1,0,8.24Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168241",
    "data-name": "Path 168241",
    d: "M30.51,48.37H23.27a1.705,1.705,0,0,0,0,3.41h7.24a1.705,1.705,0,0,0,0-3.41Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168242",
    "data-name": "Path 168242",
    d: "M40.07,58.73H11.06a2.345,2.345,0,0,1-2.34-2.35V6.49a2.343,2.343,0,0,1,2.34-2.34H21.99A2.341,2.341,0,0,1,24.06,5.4l.29.55a.326.326,0,0,0,.3.18h4.48a.346.346,0,0,0,.31-.2l.27-.52a2.331,2.331,0,0,1,2.08-1.26H42.72a2.343,2.343,0,0,1,2.34,2.34v39.4a11.316,11.316,0,0,1,3.15-1.35V5.49A4.492,4.492,0,0,0,43.71,1H10.07A4.5,4.5,0,0,0,5.56,5.49V60.5A4.509,4.509,0,0,0,10.07,65H43.71a3.971,3.971,0,0,0,.78-.07A11.388,11.388,0,0,1,40.07,58.73Zm-9.56,4.04H23.27a1.29,1.29,0,1,1,0-2.58h7.24a1.29,1.29,0,1,1,0,2.58Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168243",
    "data-name": "Path 168243",
    d: "M26.89,32.67A10.28,10.28,0,1,0,16.61,22.39,10.29,10.29,0,0,0,26.89,32.67Zm0-9.28a3.511,3.511,0,0,1-1-6.88v-.65a1,1,0,1,1,2,0v.65a3.516,3.516,0,0,1,2.52,3.36,1,1,0,0,1-2,0,1.52,1.52,0,1,0-1.52,1.52,3.511,3.511,0,0,1,1,6.88v.65a1,1,0,0,1-2,0v-.65a3.516,3.516,0,0,1-2.52-3.36,1,1,0,0,1,2,0,1.52,1.52,0,1,0,1.52-1.52Zm24.14,22.8a9.4,9.4,0,1,0,9.4,9.4A9.4,9.4,0,0,0,51.03,46.19Zm4.71,7.38-5.47,5.47a.982.982,0,0,1-.71.29,1.024,1.024,0,0,1-.71-.29l-2.53-2.53a1,1,0,0,1,1.41-1.41l1.82,1.82,4.76-4.76a1,1,0,0,1,1.43,1.41Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaySubscribe);
export default __webpack_public_path__ + "static/media/pay-subscribe.29de729259da76f76d0070ee63d15ad6.svg";
export { ForwardRef as ReactComponent };